import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

export const ExplorerOrganisationsDonut: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-donut/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationsNetwork: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-network/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationOfTheMonth: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/organisation-of-the-month`
  ),
};

export const ExplorerOrganisationsList: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/organisation/list`),
};

export const ExplorerOrganisationStats: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/organisation/stats/{code}/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationPartners: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/organisation/{code}/partners/{transactionTypeCode}`
  ),
};

export const ExplorerHomeOrganisationsDonut: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-donut/{transactionTypeCode}`
  ),
};

export const ExplorerHomeOrganisationsNetwork: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-network/{transactionTypeCode}`
  ),
};

// Organisation Page

export const ExplorerOrganisationPageOverviewStats: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/organisation/detail/{code}/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationPageLocations: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-stats/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationPageLocationsMap: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-map/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationPageSDGs: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sdgs/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationOrganisationsNetwork: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/organisation/{code}/partners/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationSectors: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/sector-donut/{transactionTypeCode}`
  ),
};

export const ExplorerOrganisationPageActivityTable: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/activity/list/{transactionTypeCode}/{page}`
  ),
};

export const ExplorerOrganisationPageDatasetTable: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/organisation/{code}/datasets`
  ),
};
